module.exports = __webpack_public_path__ + "static/media/about-us-banner.96ab45a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-us-banner.png
// module id = 1173
// module chunks = 0